/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { Column, ColumnApi, GridApi, HeaderValueGetterParams } from '@ag-grid-enterprise/all-modules'
import { GridColumnRequestModifier, GridColumnRequest } from '@/api/services/common.dto'
import { AgGridExportType, ExportedColDef } from '@/shared/models/ag-grid.model'
import { Nullable } from '@/shared/types/app.types'

@Component
export class GridExportMixin extends Vue {
    private _getGridColumnRequests(gridApi: GridApi, displayedColumns: Column[]) : GridColumnRequest[] {
        return displayedColumns
            .map((column: Column) => column.getColDef() as ExportedColDef)
            .filter((exportedColDef: ExportedColDef) => !!exportedColDef.field &&
                !exportedColDef.exportDisabled &&
                (!('exportField' in exportedColDef) || !!exportedColDef.exportField))
            .map((exportedColDef: ExportedColDef) => {
                let headerValueGetter = ''
                if (exportedColDef.headerValueGetter && exportedColDef.headerValueGetter instanceof Function) {
                    const params: HeaderValueGetterParams = {
                        api: gridApi,
                        colDef: exportedColDef,
                        location: null,
                        originalColumnGroup: null
                    }
                    headerValueGetter = exportedColDef.headerValueGetter(params)
                }
                const response: GridColumnRequest = {
                    headerName: exportedColDef.headerName ?? headerValueGetter,
                    field: exportedColDef.exportField ?? exportedColDef.field!,
                    type: exportedColDef.exportType
                }
                return response
            })
    }

    private _getGridColumnRequestsWithBarcode(gridApi: GridApi, displayedColumns: Column[], barcodeField: string): GridColumnRequest[] {
        const columnDefs = this._getGridColumnRequests(gridApi, displayedColumns)
        columnDefs.unshift({
            headerName: '',
            field: barcodeField,
            type: AgGridExportType.BARCODE,
            modifiers: [GridColumnRequestModifier.ONLY_ODD_ROWS]
        })
        columnDefs.push({
            headerName: '',
            field: barcodeField,
            type: AgGridExportType.BARCODE,
            modifiers: [GridColumnRequestModifier.ONLY_EVEN_ROWS]
        })
        return columnDefs
    }

    $_getColumnsToExport(gridApi: Nullable<GridApi>, columnApi: Nullable<ColumnApi>): Nullable<GridColumnRequest[]> {
        if (gridApi && columnApi) {
            const displayedColumns = columnApi.getAllDisplayedColumns()
            const barcodeField: string | undefined =
                columnApi.getAllGridColumns()
                    .map((column: Column) => column.getColDef() as ExportedColDef)
                    .filter((exportedColDef: ExportedColDef) => !!exportedColDef.field &&
                        (!('exportField' in exportedColDef) || !!exportedColDef.exportField) &&
                        !!exportedColDef.useForGeneratingBarcodeInExports)
                    .map(colDef => colDef.exportField ?? colDef.field)
                    .shift()

            return barcodeField
                ? this._getGridColumnRequestsWithBarcode(gridApi, displayedColumns, barcodeField)
                : this._getGridColumnRequests(gridApi, displayedColumns)
        }
        return null
    }
}
